<button
  class="context-selector__trigger"
  type="button"
  wui-button
  size="sm"
  [wuiMenu]="menu"
  [wuiMenuPosition]="menuPosition"
  [wuiTooltip]="contextSvc?.currentName()"
  [wuiTooltipDisabled]="!contextSvc?.currentName()"
  (click)="opened$.next()"
  (wuiMenuOpen)="onMenuOpen.emit()"
  (wuiMenuClose)="onMenuClose.emit()"
>
  {{ contextSvc?.currentName() || ('SelectOrg' | translate) }}
  <wf-icon
    iconPositionEnd
    iconName="chevron-selector-vertical"
    class="context-selector__trigger-icon"
  />
</button>

<ng-template #menu let-menu>
  @if (showSearch()) {
    <wf-input-search
      class="context-selector__search"
      [placeholder]="'DoSearch' | translate"
      (click)="$event.stopPropagation()"
      (change)="search$.next($event)"
    />
  }

  @if (displayData$ | async; as groups) {
    <div class="context-selector__item-wrap">
      @for (group of groups; track $index) {
        @if ($index > 0 && !group.label) {
          <div class="context-selector__section-divider"></div>
        }
        @if (group.label) {
          <div class="context-selector__section-label">
            {{ group.label | translate }}
          </div>
        }
        @for (item of group.items; track item.id) {
          @if (item?.path) {
            <a
              wuiOption
              [routerLink]="item.path"
              [active]="item.isActive ?? false"
              (click)="onOrganizationSelect(item)"
            >
              <span>{{ item.name }}</span>
            </a>
          }
        }
      }
      @if (groups.length === 0) {
        <div
          class="context-selector__item--empty"
          (click)="$event.stopPropagation()"
        >
          {{ 'OrganizationList_Empty' | translate }}
        </div>
      }
    </div>
  }

  <a
    wuiOption
    routerLink="/dashboard"
    class="context-selector__nav-link"
    (click)="onOrganizationsLinkOpen()"
  >
    <wf-icon iconName="grid-01" />
    {{ 'NavOrgList' | translate }}
  </a>

  @if (canCreateOrganization()) {
    <div class="context-selector__section-divider"></div>

    <button
      wuiOption
      type="button"
      class="context-selector__nav-link"
      data-cy="context-selector-create-org"
      (click)="onCreateOrganization()"
    >
      <wf-icon iconName="plus" />
      {{ 'AddOrganization' | translate }}
    </button>
  }
</ng-template>
